import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackGrowthStep, trackSiteVisit, withTrackingParams } from "@/lib/growth-tracking";

/** Rotas do site institucional e cadastro (nunca blogs de clientes, painel ou admin). */
export function isMarketingPath(p: string): boolean {
  return p === "/" || p.startsWith("/auth") || p.startsWith("/planos") || p.startsWith("/funcionalidades")
    || p.startsWith("/recursos") || p.startsWith("/parcerias") || p.startsWith("/ajuda") || p.startsWith("/lp");
}

/**
 * Rastreia visitas do site institucional e cliques nos CTAs de teste grátis.
 * Mantém as UTMs/códigos de clique guardados no endereço durante a navegação.
 */
export default function GrowthFunnelTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!isMarketingPath(location.pathname)) return;
    trackSiteVisit();
    // Navegação sem recarregar (navigate/Link): repõe a campanha no endereço.
    const current = location.pathname + location.search + location.hash;
    const enriched = withTrackingParams(current);
    if (enriched !== current) {
      window.history.replaceState(window.history.state, "", enriched);
    }
  }, [location.pathname, location.search, location.hash]);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (!isMarketingPath(window.location.pathname)) return;
      const target = e.target as HTMLElement | null;
      const anchor = target?.closest?.("a[href]") as HTMLAnchorElement | null;
      if (!anchor) return;
      const href = anchor.getAttribute("href") || "";
      if (!href || href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:")) return;
      // withTrackingParams não altera links externos.
      const enriched = withTrackingParams(href);
      if (enriched !== href) anchor.setAttribute("href", enriched);
      if (href.includes("/auth") && href.includes("signup")) {
        trackGrowthStep("cta_trial_click", {
          label: (anchor.innerText || "").trim().slice(0, 80),
          from: window.location.pathname,
        });
      }
    };
    document.addEventListener("click", onClick, { capture: true });
    return () => document.removeEventListener("click", onClick, { capture: true } as any);
  }, []);

  return null;
}
